import React from 'react';
import { useLocation } from 'react-router-dom';
import { useUserContext } from 'src/context/UserProvider';
import { sendTrackingEvent } from 'src/utils/gtm';
import { UIPositionStatus } from 'types';

interface Props {
	tab?: UIPositionStatus;
	setTab: (arg?: UIPositionStatus) => void;
	self: number;
	activeCompanies: number;
	allCompanies: number;
	onChange?: (arg?: UIPositionStatus) => void;
}

const AMCompaniesTabsComponent = ({ tab, setTab, activeCompanies, self, allCompanies, onChange }: Props) => {
	const location = useLocation();
	const { user } = useUserContext();
	return (
		<>
			<div className="flex w-full md:w-max dark:bg-[#1F2A37]">
				<button
					className={`flex-1 whitespace-pre ${
						tab === UIPositionStatus.SELF
							? 'bg-[#1C1C28] dark:bg-[#18222D] text-white'
							: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
					} ${
						user?.flags.isLeadGenAccountManager ? 'rounded-r-[8px]' : ''
					} !py-3 flex-1  text-center justify-center cursor-pointer !px-[2px] md:!px-4 max-h-fit leading-[20px] flex items-center border border-[#555770] border-solid rounded-l-[8px] font-inter sm:text-[14px] font-[500]`}
					onClick={() => {
						sendTrackingEvent({
							event: 'recr_dashboard_active_companies',
							eventLabel: location.pathname,
						});
						setTab(UIPositionStatus.SELF);
						onChange && onChange(UIPositionStatus.SELF);
					}}
				>
					Leads ({self})
				</button>
				{!user?.flags.isLeadGenAccountManager && (
					<>
						<button
							className={`flex-1 whitespace-pre ${
								tab === UIPositionStatus.ACTIVE
									? 'bg-[#1C1C28] dark:bg-[#18222D] text-white'
									: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
							} !py-3 text-center justify-center cursor-pointer !px-[2px] md:!px-4 max-h-fit leading-[20px] flex items-center border border-[#555770] border-solid font-inter sm:text-[14px] font-[500]`}
							onClick={() => {
								sendTrackingEvent({
									event: 'recr_dashboard_active_companies',
									eventLabel: location.pathname,
								});
								setTab(UIPositionStatus.ACTIVE);
								onChange && onChange(UIPositionStatus.ACTIVE);
							}}
						>
							Active ({activeCompanies})
						</button>
						<button
							className={`flex-1 whitespace-pre ${
								tab === UIPositionStatus.ALL_COMPANIES
									? 'bg-[#1C1C28] dark:bg-[#18222D] text-white '
									: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
							} !py-3 sm:flex-1  text-center justify-center cursor-pointer !px-[2px] md:!px-4 max-h-fit leading-[20px] flex items-center border border-[#555770] border-solid rounded-r-[8px] font-inter sm:text-[14px] font-[500]`}
							onClick={() => {
								sendTrackingEvent({
									event: 'recr_dashboard_all_companies',
									eventLabel: location.pathname,
								});
								setTab(UIPositionStatus.ALL_COMPANIES);
								onChange && onChange(UIPositionStatus.ALL_COMPANIES);
							}}
						>
							All Companies ({allCompanies})
						</button>
					</>
				)}
			</div>
		</>
	);
};

export default AMCompaniesTabsComponent;
